<template lang="pug">
.breadcrumb-container
  .breadcrumb-title {{ pageName }}
  ol.breadcrumb-items
    li.breadcrumb-item
      router-link.nav-link(to="/") 首頁
    li.breadcrumb-item.active {{ pageName }}
</template>

<script>
export default {
  name: "Breadcrumb",
  props: {
    pageName: String,
  },
};
</script>

<style scoped lang="scss">
a {
  color: $color_water_blue !important;
}
</style>
